import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { api } from '@app/utils/api';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { ServerError } from '@app/error/ServerError';

export const fetch = async ({ id }: { id: number }): Promise<void> => {
  try {
    await api.delete<void>(`${PANEl_BASE_URL}/clients/clients/${id}/delete_client/`);
  } catch (e: any) {
    throw new ServerError(e.response.data.error);
  }
};

export const useDeleteHosting = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
